import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import api from "@/lib/axios"
import SkeletonTable from "@/components/SkeletonTable"

const getListJenisPrestasi = async () => {
  const response = await api.get("/master/jenis-prestasi/index", {
    withCredentials: true,
  })
  return response.data?.data
}

export default function MasterJenisPrestasiPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listJenisPrestasi"],
    queryFn: getListJenisPrestasi,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
